module.exports = __webpack_public_path__ + "static/img/YG.9c2a8ae2.png";